import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

export const OnFooterClick = (router: AppRouterInstance, pageIndex: number, centerId: string, primary?: boolean) => {
  if (primary) router.push(`/robot/${++pageIndex}?centerId=${centerId}`);
  else router.push(`/robot?centerId=${centerId}`);
};
